import $axios from '../backend/vue-axios/axios.js'

const state = {
  logs: []
}

const mutations = {
  setLogs (state, payload) {
    payload.forEach(function (i) {
      i.userId.forEach(function (ui) {
        ui.email = i.email
        state.logs.push(ui)
      })
    })
  },
  clearLogState (state) {
    state.logs = []
  }
}
const getters = {
  getLogs (state) {
    return state.logs
  }
}
const actions = {
  callLogs ({commit}, payload) {
    var url = payload
    commit('clearLogState')
    $axios.get(url)
    .then((response) => {
      commit('setLogs', response.data)
    })
  }
}
export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/logs.js